import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";
import { Reveal } from "./Reveal";

export const CtaBand = ({
  title = "Ready to Move Your Fitness Business Forward?",
  text = "Tell us about your fitness, sports, or wellness business. We'll help you explore the right digital solutions for attracting customers, simplifying operations, and building a stronger online presence.",
  waText,
}) => (
  <section className="container-x py-16 md:py-24" data-testid="cta-band">
    <div className="grain relative overflow-hidden rounded-2xl bg-ink px-6 py-14 sm:px-12 md:py-20 on-dark">
      <svg className="pointer-events-none absolute -right-24 -top-24 h-[420px] w-[420px] text-lime/25" viewBox="0 0 200 200" fill="none" aria-hidden>
        <path d="M20 180 L100 20 L180 180" stroke="currentColor" strokeWidth="1.2" />
        <path d="M45 180 L100 70 L155 180" stroke="currentColor" strokeWidth="1.2" />
        <path d="M70 180 L100 120 L130 180" stroke="currentColor" strokeWidth="1.2" />
      </svg>
      <div className="relative max-w-3xl">
        <Reveal><h2 className="h2 text-white">{title}</h2></Reveal>
        <Reveal delay={0.08}><p className="mt-6 text-base md:text-lg leading-relaxed text-white/75">{text}</p></Reveal>
        <Reveal delay={0.16} className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Link to="/contact#inquiry" className="btn-lime" data-testid="cta-band-discuss-btn">
            Discuss Your Project <ArrowRight className="h-4 w-4" aria-hidden />
          </Link>
          <a href={waLink(waText)} target="_blank" rel="noopener noreferrer" className="btn-ghost-dark" data-testid="cta-band-whatsapp-btn">
            <MessageCircle className="h-4 w-4" aria-hidden /> Chat on WhatsApp
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
